import * as React from 'react';
import { useMemo, useState } from 'react';
import Layout from '../components/layout';
import { graphql, Link } from 'gatsby';
import Background from '../components/background';
import JobRow from '../components/jobRow';
import Img from 'gatsby-image';
import Search from '../components/search';
import NewsLetterForm from '../components/forms/newsLetterForm';

const Index = ({ data, location }) => {
  const { page } = data;
  const posts = useMemo(() => data.posts.edges.map(e => e.node), [data.posts.edges]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [selectedEmployerTypes, setSelectedEmployerTypes] = useState([]);

  return (
    <Layout location={location} title='Jobb för juriststudenter' className='min-h-screen flex flex-col'>
      <div className='w-full h-screen md:h-[75vh] flex flex-col items-center justify-center relative pt-36'>
        <Background src={page.indexBackground.fluid} alt={page.indexBackground.title} className='h-full' blur />
        <div className='flex flex-col items-center space-y-1 md:space-y-4 z-10 text-center px-2'>
          <p className='text-2xl md:text-4xl lg:text-5xl md:max-w-screen-sm'>{page.heading}</p>
          <p className='text-lg md:text-xl'>{page.subHeading}</p>
        </div>
      </div>
      <Search posts={posts} setPosts={setFilteredPosts} location={location} selectedIndustries={selectedIndustries}
              selectedTypes={selectedTypes} selectedPeriod={selectedPeriod} selectedAreas={selectedAreas}
              selectedEmployerTypes={selectedEmployerTypes} setSelectedIndustries={setSelectedIndustries}
              setSelectedTypes={setSelectedTypes} setSelectedPeriod={setSelectedPeriod}
              setSelectedAreas={setSelectedAreas} setSelectedEmployerTypes={setSelectedEmployerTypes} />
      <div className='bg-white w-full flex flex-col items-stretch pt-12 pb-48 space-y-12 max-w-screen-xl mx-auto px-2'>
        {filteredPosts.some(post => post.prioritized) &&
        <p className='mr-auto text-2xl font-bold text-primary -mt-6 -mb-6'>Populära annonser</p>}
        {filteredPosts.map((post, index) => (
          <JobRow key={post.id} data={post} even={index % 2 === 0} selectedIndustries={selectedIndustries}
                  selectedTypes={selectedTypes} selectedPeriod={selectedPeriod} selectedAreas={selectedAreas}
                  selectedEmployerTypes={selectedEmployerTypes} />
        ))}
        {filteredPosts.length === 0 &&
        <p className='text-center text-lg'>Inga annonser matchade dina sökparametrar.</p>}
      </div>
      <div className='w-full bg-[#F5C62B] py-16'>
        <div
          className='flex flex-col lg:flex-row space-y-16 lg:space-y-0 lg:space-x-32 w-full max-w-screen-xl mx-auto px-2 lg:px-16 xl:px-0'>
          <div className='flex flex-col lg:pt-32 space-y-12 lg:space-y-24'>
            <div className='flex flex-col space-y-2 lg:space-y-4 items-center lg:items-start px-2'>
              <p className='text-2xl lg:text-4xl'>Söker du stjärnstudenter till din verksamhet?</p>
              <p className='text-lg lg:text-2xl font-light'>Annonsera på Sveriges bästa jobbannonssida för
                juriststudenter.</p>
              <Link to='/arbetsgivare'
                    className='btn-outline-inverse text-base lg:text-xl'>
                Läs mer om hur du kan annonsera
              </Link>
            </div>
            <div className='flex flex-col space-y-2 lg:space-y-4 items-center lg:items-start px-2'>
              <p className='text-xl lg:text-3xl'>Vill du veta när det kommer nya annonser?</p>
              <p className='text-lg lg:text-2xl font-light'>Registrera din e-post och ta del av vårat nyhetsbrev.</p>
              <NewsLetterForm />
            </div>
          </div>
          <div className='flex flex-col flex-grow md:w-[500px] mx-auto'>
            <Img
              fixed={page.indexImage1.fixed}
              alt={page.indexImage1.title}
              className='!w-[300px] md:!w-[400px] h-[250px] rounded-xl shadow'
            />
            <Img
              fixed={page.indexImage2.fixed}
              alt={page.indexImage2.title}
              className='w-[300px] h-[350px] rounded-xl shadow self-end -mt-20 -mr-4'
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Index;

export const query = graphql`
    query {
        page: contentfulHemsida {
            heading
            subHeading
            indexBackground {
                title
                fluid(maxWidth: 2500, quality: 90) {
                    ...GatsbyContentfulFluid_withWebp
                }
            }
            indexImage1 {
                title
                fixed(width: 400, height: 250, quality: 90) {
                    ...GatsbyContentfulFixed_withWebp
                }
            }
            indexImage2 {
                title
                fixed(width: 300, height: 350, quality: 90) {
                    ...GatsbyContentfulFixed_withWebp
                }
            }
        }
        posts: allContentfulAnnons(filter: { contentful_id: { ne: "7ttcDV90DNUEKges0ZNMVD" } }) {
            edges {
                node {
                    id
                    contentful_id
                    fields {
                        slug
                    }
                    createdAt
                    title
                    employer
                    employerType
                    minPeriod
                    lastApplicationDate
                    industry
                    type
                    area
                    prioritized
                    priority
                    image {
                        title
                        fixed(width: 150, height: 150, quality: 90) {
                            ...GatsbyContentfulFixed_withWebp
                        }
                    }
                }
            }
        }
    }
`;